module.exports = __webpack_public_path__ + "static/media/activity.f4c817e6.jpg";